import { Timestamp } from "firebase/firestore";
import CheckBoxGrey from "../../../textfields/CheckBoxGrey";
import { getFlutterTime } from "../../../models/DataFunctions";
import TextField2T from "../../../textfields/TextField2T";
import MLTFGPT3 from "../../../textfields/MLTFGPT3";

export const generateID = (prefix: string): string => {
  let randomPart = Math.random().toString(36).substring(2, 30);
  //let date As 2025-04-12
  let date = new Date();
  let formattedDate = date.toISOString().split("T")[0].replace(/-/g, "");
  return `${prefix}_${formattedDate}_${randomPart}`;
};

export const InfosBlockModify = ({
  label,
  value,
  onChange = (value: string) => {},
  disabled = false,
  items = [],
  onSuggestedValue,
  multiline = false, // Optional prop for multiline input
  type = "text", // Optional type for the input field
  onOpenSuggestions = undefined, // Optional suggestions for the input field
  suggestion_selected = false, // Optional actual suggestion ID for the input field
}: {
  label: string;
  value: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  items?: { label: string }[];
  onSuggestedValue?: (value: string) => void; // Optional callback for suggested values
  multiline?: boolean; // Optional prop for multiline input
  type?: "text" | "number" | "email" | "tel"; // Optional type for the input field
  onOpenSuggestions?: () => void; // Optional function to handle opening suggestions
  suggestion_selected?: boolean; // Optional actual suggestion ID for the input field
}) => {
  return (
    <div className="flex flex-row gap-2 items-center">
      {multiline ? (
        <MLTFGPT3
          label={label}
          value={value}
          onChange={(e) => {
            // Handle the change event, e.g., update state or call a function
            onChange(e.target.value);
          }}
        ></MLTFGPT3>
      ) : (
        <TextField2T
          label={label}
          value={value}
          onChange={(e) => {
            // Handle the change event, e.g., update state or call a function
            onChange(e.target.value);
          }}
          disabled={disabled}
          className="w-full"
          items={items}
          type={type}
          onSuggestedValue={onSuggestedValue}
        ></TextField2T>
      )}
    </div>
  );
};

export const CheckBlock = ({
  label,
  value,
  onChange = (checked: boolean) => {},
}: {
  label: string;
  value: boolean;
  onChange?: (checked: boolean) => void;
}) => {
  return (
    <div className="flex flex-row gap-2 items-center ">
      <CheckBoxGrey
        checked={value}
        onChange={onChange}
        className="w-c20 h-c20"
      />
      <div className="text-h3 text-shadow_75">{label}</div>
    </div>
  );
};
export const getRemainingDays = (date: Timestamp): number => {
  const diffTime = date.seconds - getFlutterTime().seconds;
  return Math.ceil(diffTime / (60 * 60 * 24));
};
